import { checkImageSize } from './formats';

export type ResizeAxis = 'width' | 'height';
export type ResizeOptions =
  | { mode: 'canvas'; width: number; height: number }
  | { mode: 'proportional'; axis: ResizeAxis; size: number };
export type ResizeOutputFormat = 'png' | 'jpg' | 'webp';
export type PixelBounds = { x: number; y: number; width: number; height: number };

export function validateResizeOptions(options: ResizeOptions) {
  if (options.mode === 'proportional') {
    if (options.axis !== 'width' && options.axis !== 'height') throw new Error('Chọn chiều rộng hoặc chiều cao để scale.');
    if (!Number.isInteger(options.size) || options.size < 1) throw new Error('Nhập một cạnh bằng số nguyên lớn hơn 0.');
    checkImageSize(options.size, 1);
  } else if (options.mode === 'canvas') {
    if (!Number.isInteger(options.width) || !Number.isInteger(options.height) || options.width < 1 || options.height < 1) {
      throw new Error('Chiều rộng và chiều cao phải là số nguyên lớn hơn 0.');
    }
    checkImageSize(options.width, options.height);
  } else throw new Error('Chế độ resize không hợp lệ.');
}

// The chosen edge is exact; the other edge follows each source image's aspect ratio.
export function resizeDimensions(sourceWidth: number, sourceHeight: number, options: ResizeOptions) {
  validateResizeOptions(options);
  checkImageSize(sourceWidth, sourceHeight);
  const width = options.mode === 'canvas' ? options.width : options.axis === 'width' ? options.size : Math.max(1, Math.round(sourceWidth * options.size / sourceHeight));
  const height = options.mode === 'canvas' ? options.height : options.axis === 'height' ? options.size : Math.max(1, Math.round(sourceHeight * options.size / sourceWidth));
  checkImageSize(width, height);
  return { width, height };
}

// Contain the complete image without stretching, then center in the requested canvas.
export function fitImage(sourceWidth: number, sourceHeight: number, width: number, height: number): PixelBounds {
  checkImageSize(sourceWidth, sourceHeight);
  checkImageSize(width, height);
  const ratio = Math.min(width / sourceWidth, height / sourceHeight);
  const drawWidth = Math.min(width, Math.max(1, Math.round(sourceWidth * ratio)));
  const drawHeight = Math.min(height, Math.max(1, Math.round(sourceHeight * ratio)));
  return { x: Math.floor((width - drawWidth) / 2), y: Math.floor((height - drawHeight) / 2), width: drawWidth, height: drawHeight };
}

export function hasTransparency(rgba: Uint8ClampedArray): boolean {
  for (let index = 3; index < rgba.length; index += 4) if (rgba[index] < 255) return true;
  return false;
}
